import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useAuth0 } from "@/Services/Auth0/auth0-plugin";
    import { Auth0 } from '@/Services/Auth0/auth0-interface'
    
    
export default /*#__PURE__*/_defineComponent({
  __name: 'LogoutButton',
  setup(__props) {

    const auth0: Auth0 | null = useAuth0();

    const logout = () => {
        if (!auth0) {
            return;
        }

        auth0.logout({
            logoutParams: {
                returnTo: window.location.origin
            }
        });
    };

            

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "button button--primary button--compact",
    onClick: logout
  }, " Log Out "))
}
}

})